import api from '../../api/_cpn'


const state = () => ({
    cpn_grossesse_courante: [],
    examen_options: [],
    cpn_exam_physique: []
})

// getters
const getters = {
    cpn_grossesse_courante: (state) => {
        return state.cpn_grossesse_courante
    },
    cpn_examens_physiques_courante: (state) => {
        return state.cpn_exam_physique
    },

    examen_options: (state) => {
        return state.examen_options
    },
}

// actions
const actions = {
    saveGrossesseCpn({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.saveGrossesseCpn(data).then(
                response => {
                    commit
                    resolve(response);
                }, error => {

                    reject(error);
                }
            )
        })
    },

    /**
     * Récupérer les données d'une grossese d'une CPN en cours
     * @param {*} param0 
     * @param {*} data 
     * @returns 
     */
    getGrossesseEnCours({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getGrossesseEnCours(data.consultation_id).then(
                response => {
                    commit('SET_GROSSESSE_COURANTE', response)
                    resolve(response)
                }, error => {
                    reject(error);
                }
            )
        })
    },

    getExamensPhysiquesEnCours({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getExamensPhysiquesEnCours(data.consultation_id).then(
                response => {
                    commit('SET_EXAM_PHYSIQUE_COURANTE', response);
                    resolve(response)
                }, error => {
                    reject(error);
                }
            )
        })
    },


    getAllParamCpn({ commit }) {
        return new Promise((resolve, reject) => {
            api.getAllParamCpn().then(
                response => {
                    commit('SET_CPN_EXAM_OPTIONS', response)
                    resolve(response);
                }, error => {

                    reject(error);
                }
            )
        })
    },
    saveExamensPhysiquesCpn({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.saveExamensPhysiquesCpn(data).then(
                response => {
                    commit;
                    resolve(response);
                }, error => {
                    reject(error);
                }
            )
        })

    },

    saveHypotheseDiagnosticCpn({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.saveHypotheseDiagnosticCpn(data).then(
                response => {
                    commit
                    resolve(response);
                }, error => {

                    reject(error);
                }
            )
        })

    },


}

// mutations
const mutations = {
    SET_GROSSESSE_COURANTE(state, cpn_grossesse_courante) {
        state.cpn_grossesse_courante = cpn_grossesse_courante
    },
    SET_EXAM_PHYSIQUE_COURANTE(state, cpn_exam_phys_courante) {
        state.cpn_exam_physique = cpn_exam_phys_courante
    },
    SET_CPN_EXAM_OPTIONS(state, examen_options) {
        state.examen_options = examen_options
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}